import post from './methods/post';

export default {
	post: (uuid) => post('emailverification/verify/' + uuid, {}, {}, true),
};
